<template>
    <span v-if="configs.visible">
    <ul class="breadcrumb" :class="ulClasses" :style="ulStyle" 
      style="padding: 4px 15px; height: 27px;">
        <i v-if="selectors.start > 0" class="nav_breadcrumb" :class="$root.icons.left" aria-hidden="true" 
            style="display:inline-block; cursor: pointer;" @click="!$root.help ? showParent() : ''"></i>
        <li :key="item.id" v-for="(item, index) in displayed" :style="liStyle" class="next">
            <a class="underline" href="#" @click.prevent="!$root.help ? nav(item.id) : ''">{{item.des}}</a>
            <a v-if="index == 0 && $Behaviors.updateReference == 'date'" style="padding-left: 0px;">({{date}})</a>
            <span v-if="index < displayed.length-1">{{separator}}</span>
        </li>
        
        <span v-if="selectors.end < nodes.length-1"><i class="nav_breadcrumb" :class="$root.icons.right" aria-hidden="true" 
            style="display:inline-block; cursor: pointer;" @click="!$root.help ? showChildren() : ''"></i> ...</span>
      
    </ul>
    <ul v-if="$root.active_tree_item.id" class="top-breadcrumb" style="padding: 4px 15px; margin: 0px;">
      <dynIcon 
        :configs="{ID: 'father_detail', visible: true}"  
        :exec="!$root.help ? showFatherDetail : $root.trigger_help" 
        :execParam="!$root.help ? [$root.active_tree_item] : ['father_detail']" 
        :hoverParam="'father_detail'"
        :icnClasses="[fatherIcon]"  
        :styleObj="{'margin-right': '5px', 'cursor':'pointer', 'font-size':'1.1em'}"> 
      </dynIcon> 

      <div style="display:inline; font-family: 'Source Sans Pro';">{{' ' + $root.active_tree_item.id + '  -  ' + $root.active_tree_item.des}}</div></i></ul>
    </span>
</template>
<script>
import { eventBus } from "../../eventbus";
import dynIcon from "../dynamic/DynIcon.vue";

export default {
  components: {
    dynIcon
  },
  props: {
    configs: {
      type: Object,
      default: function() {
        return {
          full_path: false,
          nodes_shown: 3,
          visible: false
        };
      }
    },
    ulClasses: String,
    ulStyle: Object,
    liStyle: Object
  },
  created: function() {
    var vm = this;
    if (this.configs.visible) {
      eventBus.$on("active_changed", this.makeBreadcrumb);
    }
    this.$nextTick(() => {
      this.fatherIcon = this.$root.icons.info;
    });

    eventBus.$on('date', (d)=>{
      console.log(d)
      vm.date = new Date(d).toLocaleDateString()
      console.log(vm.date)
    })

    try{
      var v = sessionStorage.getItem("validity");
      this.date = new Date(JSON.parse(v).value).toLocaleDateString()
    }catch(err){}

  },
  watch:{
    configs: function(){
      this.makeBreadcrumb();
    }
  },
  data: function() {
    return {
      nodes: [],
      displayed: [],
      selectors: {},
      separator: " - ",
      fatherIcon: "",
      date: ""
    };
  },
  methods: {
    makeBreadcrumb: function() {
      
      this.nodes = [];
      this.displayed = [];
      var working_array = [];
      if (this.$root.active_tree_path) {
        working_array = this.$root.active_tree_path;
      }
      
      var index = -1;
      var vm_root = this.$root.index_as_root;
   
      working_array.forEach(function(obj, i) {
        if (obj.id == vm_root) {
          index = i;
        }
      });
      if (index > 0) {
        //solo se non ho caricato l'intero catalogo
        working_array.splice(0, index); //cancella elementi array dall'inizio al elem corrente
      }
      this.nodes = working_array;
      if (this.nodes.length <= this.configs.nodes_shown) {
        //non ho raggiunto il num max di nodi visibili
        this.selectors = {};
        this.displayed = this.nodes;
      } else {
        this.selectors = {
          //tengo conto degli indici di inizio e fine
          start: this.nodes.length - this.configs.nodes_shown,
          end: this.nodes.length - 1
        };
        this.displayed = this.nodes.slice(
          this.selectors.start,
          this.selectors.end + 1
        ); //prendo ultimi 3 elem (end+1 perchè l'ultimo è escluso)
      }
    },
    showParent: function() {
      this.selectors.start = this.selectors.start - 1;
      this.selectors.end = this.selectors.end - 1;
      this.displayed = this.nodes.slice(
        this.selectors.start,
        this.selectors.end + 1
      );
    },
    showChildren: function() {
      this.selectors.start = this.selectors.start + 1;
      this.selectors.end = this.selectors.end + 1;
      this.displayed = this.nodes.slice(
        this.selectors.start,
        this.selectors.end + 1
      );
    },
    nav: function(id) {
      if (this.$root.active_tree_item.id != id) {
        
        var slicing = []
        for(var i = 0; i < this.$root.active_tree_path.length; i++){
          if(this.$root.active_tree_path[i].id == id){
            break;
          } else {
            slicing.push(this.$root.active_tree_path[i].id)
          }
        }
        slicing = slicing.join("?")
        console.log(id)
        this.$root.navigateTo(id, null, null, slicing);
      }
    },
    showFatherDetail(elem) {
      eventBus.$emit("openFatherDetailModal", elem);
    }
  }
};
</script>
<style scoped>
a {
  padding: 0px 8px;
  color: inherit;
}
a.sep {
  color: #888;
}
a.sep:hover {
  cursor: default;
}

.breadcrumb .next::before {
  content: none;
}

.underline {
  text-decoration: underline;
}

ul.breadcrumb {
  /*
  background-color: white !important;
  color: #3c8dbc !important;
  */
}

i.btn {
  color: #3c8dbc;
  padding: 1px 4px;
  margin: 0px 4px;
  border-radius: 2px;
  position: relative;
  top: -1px;
}
</style>


// WEBPACK FOOTER //
// src/components/tree/breadcrumb.vue?0de293f2